import { useAccount } from "@Light/components/page/account";
import { loadStripe, Stripe } from "@stripe/stripe-js";

const stripeCache = new Map<string, Promise<Stripe | null>>();

export function useStripePromise(): Promise<Stripe | null> | null {
  const publicKey = useAccount().app.stripe_public_key;

  if (!publicKey) {
    return null;
  }

  if (!stripeCache.has(publicKey)) {
    stripeCache.set(
      publicKey,
      loadStripe(publicKey, {
        developerTools: { assistant: { enabled: false } },
      }),
    );
  }

  return stripeCache.get(publicKey) ?? null;
}
